<template>
<div class="chapter">
<div class="inner_page">
<h3 class="t3b">PREFACE
</h3>
<p class="calibre7">
This, the fourth volume of <i class="calibre9">The British Campaign in
France and Flanders</i>, carries the story through the
long and arduous fighting of 1917, which culminated
in the dramatic twofold battle of Cambrai.  These
events are cut deep into the permanent history of
the world, and we are still too near it to read the
whole of that massive and tremendous inscription.
It is certain, however, that this year marked the
period in which the Allies gained a definite military
ascendancy over the German forces, in spite of the
one great subsequent rally which had its source in
events which were beyond the control of the Western
powers.  So long as ink darkens and paper holds,
our descendants, whose freedom has been won by
these exertions, will dwell earnestly and with reverence
upon the stories of Arras, Messines, Ypres, Cambrai,
and other phases of this epic period.
</p>
<p class="calibre7">
I may be permitted to record with some thankfulness
and relief, that in the course of three thick
volumes, in which for the first time the detailed battle-line
of these great encounters has been set out, it has
not yet been shown that a brigade has ever been
out of its place, and even a battalion has seldom
gone amiss.  Such good fortune cannot last for ever.
<i class="calibre9">Absit omen!</i>  But the fact is worth recording, as it
<a id="Pvi" title="{vi}"></a>
may reassure the reader who has natural doubts
whether history which is so recent can also lay claim
to be of any permanent value.
</p>
<p class="calibre7">
The Censorship has left me untrammelled in the
matter of units, for which I am sufficiently grateful.
The ruling, however, upon the question of names
must be explained, lest it should seem that their
appearance or suppression is due to lack of knowledge
or to individual favour or caprice.  I would explain,
then, that I am permitted to use the names of Army
and Corps Commanders, but only of such divisional
Generals as are mentioned in the Headquarters
narrative.  All other ranks below divisional Generals
are still suppressed, save only casualties, in connection
with the action where they received the injury, and
those who won honours, with the same limitation.
This regulation has little effect upon the accuracy of
the narrative, but it appears in many cases to involve
some personal injustice.  To record the heroic deeds
of a division and yet be compelled to leave out the
name of the man who made it so efficient, is painful
to the feelings of the writer, for if any one fact is
clearer than another in this war it is that the good
leader makes the good unit.
</p>
<p class="calibre7">
The tremendous epic of 1918 will call for two
volumes in its treatment.  One of these, bringing the
story up to June 30, 1918, is already completed, and
should appear by the summer.  The other may be
ready at the end of the year.
</p>
<p class="noindent">
ARTHUR CONAN DOYLE.
</p>
<p class="noindent">
  CROWBOROUGH,<br class="calibre8"/>
<i class="calibre9">January</i> 20, 1919.<br class="calibre8"/>
</p>
<p class="calibre7">
<a id="Pvii" title="{vii}"></a>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?18470806